import React, { useEffect, useRef, useState } from 'react'
import styles from './DisplayBoard/DisplayBoard.module.css';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from 'utils/constants';
import { RichBox } from 'components/RichBoxComponent';



const DisplayBoard = (props) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    // -------------------------------------------------------------------------------
    const [methods_material, setmethods_material] = useState("")
    const [methods_materialBar, setmethods_materialBar] = useState(0);
    const [display_board_status, setdisplay_board_status] = useState(0);
    // -------------------------------------------------------------------------------
    const [res_data, setres_data] = useState("")
    const [res_dataBar, setres_dataBar] = useState(0);
    // -------------------------------------------------------------------------------

    // const project_nameRef = useRef(null)
    const [project_name, setProject_name] = useState("")
    const [project_nameBar, setproject_nameBar] = useState(0);
    // const abstractRef = useRef(null)
    const [abstract, setAbstract] = useState("")
    const [abstractBar, setabstractBar] = useState(0);
    // const introRef = useRef(null)
    const [intro, setIntro] = useState("")
    const [introBar, setintroBar] = useState(0);
    // const conclusionRef = useRef(null)
    const [conclusion, setConclusion] = useState("")
    const [conclusionBar, setconclusionBar] = useState(0);
    // const recommendationRef = useRef(null)
    const [recommendation, setRecommendation] = useState("")
    const [recommendationBar, setrecommendationBar] = useState(0);
    // const refrencesRef = useRef(null)
    const [refrences, setRefrences] = useState("");
    const [refrencesBar, setrefrencesBar] = useState(0);
    // const acknowledgementRef = useRef(null)
    const [acknowledgement, setAcknowledgement] = useState("");
    const [acknowledgementBar, setacknowledgementBar] = useState(0);

    const [statusText, setStatusText] = useState("Pending");
    const [statusStyles, setStatusStyles] = useState({
        0: styles.status0,
        1: styles.status1,
        2: styles.status2,
    })

    useEffect(() => {
        // displayBoardStatus
        let tmp;
        switch ((display_board_status  ?? 0 - 0)) {
            case 1:
                tmp = "Approved"
                break;

            case 2:
                tmp = "Update requested"
                break;

            default:
                tmp = "Pending"
                break;
        }
        setStatusText(tmp)
        return () => {

        }
    }, [display_board_status])

    useEffect(() => {

        Swal.showLoading();
        axios.get(`${BASE_URL}/capstone/displayboard/getdisplayboard.php`)
            .then(res => {
                let hasFailedFlag = true
                if (res?.data?.data) {
                    const res_data_data = res?.data?.data;
                 
                    if (res_data_data.hasOwnProperty("displayboard")) {
                        hasFailedFlag = false
                        let temp_display_board_status = res_data_data?.display_board_status - 0;
                        setdisplay_board_status(temp_display_board_status)
                        const tmp_displayboard = res_data_data?.displayboard;

                        if (tmp_displayboard?.hasOwnProperty("project_name")) {
                            setProject_name(tmp_displayboard["project_name"])
                        }

                        if (tmp_displayboard?.hasOwnProperty("project_name_bar")) {
                            setproject_nameBar(tmp_displayboard["project_name_bar"] ?? 0)
                        }
                        if (tmp_displayboard?.hasOwnProperty("abstract")) {
                            setAbstract(tmp_displayboard["abstract"])
                        }

                        if (tmp_displayboard?.hasOwnProperty("abstract_bar")) {
                            setabstractBar(tmp_displayboard["abstract_bar"] ?? 0)
                        }
                        if (tmp_displayboard?.hasOwnProperty("intro")) {
                            setIntro(tmp_displayboard["intro"])
                        }

                        if (tmp_displayboard?.hasOwnProperty("intro_bar")) {
                            setintroBar(tmp_displayboard["intro_bar"] ?? 0)
                        }
                        
                        if ((temp_display_board_status  ?? 0 - 0) == 1) {
                            // -------------------------------------------------------------------------------
                            if (tmp_displayboard?.hasOwnProperty("methods_material")) {
                                setmethods_material(tmp_displayboard["methods_material"])
                            }
                            if (tmp_displayboard?.hasOwnProperty("methods_material_bar")) {
                                setmethods_materialBar(tmp_displayboard["methods_material_bar"] ?? 0)
                            }
                            // -------------------------------------------------------------------------------
                            
                            if (tmp_displayboard?.hasOwnProperty("res_data")) {
                                setres_data(tmp_displayboard["res_data"])
                            }
                            if (tmp_displayboard?.hasOwnProperty("res_data_bar")) {
                                setres_dataBar(tmp_displayboard["res_data_bar"] ?? 0)
                            }
                            if (tmp_displayboard?.hasOwnProperty("conclusion")) {
                                setConclusion(tmp_displayboard["conclusion"])
                            }

                            if (tmp_displayboard?.hasOwnProperty("conclusion_bar")) {
                                setconclusionBar(tmp_displayboard["conclusion_bar"] ?? 0)
                            }
                            if (tmp_displayboard?.hasOwnProperty("recommendation")) {
                                setRecommendation(tmp_displayboard["recommendation"])
                            }

                            if (tmp_displayboard?.hasOwnProperty("recommendation_bar")) {
                                setrecommendationBar(tmp_displayboard["recommendation_bar"] ?? 0)
                            }
                            if (tmp_displayboard?.hasOwnProperty("refrences")) {
                                setRefrences(tmp_displayboard["refrences"])
                            }

                            if (tmp_displayboard?.hasOwnProperty("refrences_bar")) {
                                setrefrencesBar(tmp_displayboard["refrences_bar"] ?? 0)
                            }
                            if (tmp_displayboard?.hasOwnProperty("acknowledgement")) {
                                setAcknowledgement(tmp_displayboard["acknowledgement"] ?? 0)
                            }

                            if (tmp_displayboard?.hasOwnProperty("acknowledgement_bar")) {
                                setacknowledgementBar(tmp_displayboard["acknowledgement_bar"] ?? 0)
                            }

                        }

                    }
                }
                if (hasFailedFlag) {
                    Swal.fire("Sorry, try again later", "", "error")
                } else {
                    Swal.close();
                    setDataLoaded(true)
                }
            }).catch(err => {
                
                Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

            })


        return () => {

        }
    }, [])


    const handleSend = (field, text, bar) => {
        if (text?.trim() !== "") {
          
            Swal.showLoading();
            axios.post(`${BASE_URL}/capstone/displayboard/setdisplayboard.php`, {
                field: field,
                content: text,
                bar
            })
                .then(res => {
                    let hasFailedFlag = true
                    if (res?.data?.data) {
                        const res_data_data = res?.data?.data;
                     
                        if (res_data_data.hasOwnProperty("ok")) {
                            hasFailedFlag = false
                            Swal.fire("Saved", "", "success")
                        }
                    }
                    if (hasFailedFlag) {
                        Swal.fire("Sorry, try again later", "", "error")
                    }
                }).catch(err => {
                    Swal.fire(err?.response?.data?.msg || "Sorry, try again later", "", "error")

                })


        }
    };


    if (!dataLoaded) {
        return <h2>Loading...</h2>
    } else {
        return (
            <div>
                <div className={styles.capstone_idea_status} >
                    <h5 className={styles.capstone_idea_status_text} >Capstone Idea Status: &nbsp; </h5>

                    <span
                        className={`${styles.status} ${(statusStyles.hasOwnProperty((display_board_status  ?? 0 - 0))) ? statusStyles[(display_board_status  ?? 0 - 0)] : ""}`}
                    >
                        {statusText}
                    </span>
                </div>
                <p style={{ color: "red" }} >*Note that the "Save" button is for the whole section , so if you modify either of the slider or the text you need to push it.</p>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Project Name</ h4>
                        <input
                            // ref={project_nameRef}
                            value={project_name ??""}
                            onChange={e => { setProject_name(e?.target?.value) }}
                            style={{
                                borderRadius: "10px",
                                border: "1px solid",
                                flex: "1",
                            }}
                        />
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                value={project_nameBar??0}
                                onChange={e => {
                                    setproject_nameBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{project_nameBar}%</span>
                            </span>
                        </div>
                    </div>

                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "project_name"
                                const text = project_name
                                const bar = project_nameBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Abstract</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                value={abstractBar??0}
                                onChange={e => {
                                    setabstractBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{abstractBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={abstractRef}
                        value={abstract??""}
                        onChange={e => { setAbstract(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "abstract"
                                const text = abstract
                                const bar = abstractBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Introduction</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                value={introBar??0}
                                onChange={e => {
                                    setintroBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{introBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={introRef}
                        value={intro??""}
                        onChange={e => { setIntro(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            onClick={(e) => {
                                const field = "intro"
                                const text = intro
                                const bar = introBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    {/* <div className={styles.title} >
                        < h4 className={styles.titleH1} >Selected Solution</ h4>
                    </div> */}

                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Methods and Materials</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                disabled={((display_board_status  ?? 0 - 0) != 1)}
                                style={{
                                    width: "90px",
                                }}
                                value={methods_materialBar??0}
                                onChange={e => {
                                    setmethods_materialBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{methods_materialBar}%</span>
                            </span>
                        </div>
                    </div>
                    {

                        ((display_board_status  ?? 0 - 0) != 1) ?
                            <textarea value={""} disabled={((display_board_status  ?? 0 - 0) != 1)} className={styles.my_textarea} name="" id="" cols="30" rows="10"

                            />
                            :
                            <RichBox
                                disabled={((display_board_status  ?? 0 - 0) != 1)}
                                defaultValue={methods_material}
                                onChange={setmethods_material}
                            />
                    }
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            disabled={((display_board_status  ?? 0 - 0) != 1)}
                            onClick={(e) => {
                                const field = "methods_material"
                                const text = methods_material
                                const bar = methods_materialBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Results and data analysis</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                disabled={((display_board_status  ?? 0 - 0) != 1)}
                                style={{
                                    width: "90px",
                                }}
                                // className='displayboardSectionInput'
                                value={res_dataBar??0}
                                onChange={e => {
                                    setres_dataBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{res_dataBar}%</span>
                            </span>
                        </div>
                    </div>
                  
                    {
                        ((display_board_status  ?? 0 - 0) != 1) ?
                            <textarea value={""} disabled={((display_board_status  ?? 0 - 0) != 1)} className={styles.my_textarea} name="" id="" cols="30" rows="10"

                            />
                            : 
                            <RichBox
                                disabled={((display_board_status  ?? 0 - 0) != 1)}
                                defaultValue={res_data}
                                onChange={setres_data}
                            />
                    }
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >
                        <button className='btn btn-primary'
                            disabled={((display_board_status  ?? 0 - 0) != 1)}
                            onClick={(e) => {
                                const field = "res_data"
                                const text = res_data
                                const bar = res_dataBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}


                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Conclusion</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                disabled={((display_board_status  ?? 0 - 0) != 1)}
                                style={{
                                    width: "90px",
                                }}
                                value={conclusionBar ?? 0}
                                onChange={e => {
                                    setconclusionBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{conclusionBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea disabled={((display_board_status  ?? 0 - 0) != 1)} className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={conclusionRef}
                        value={conclusion ??""}
                        onChange={e => { setConclusion(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >


                        <button className='btn btn-primary'
                            disabled={((display_board_status  ?? 0 - 0) != 1)}
                            onClick={(e) => {
                                const field = "conclusion"
                                const text = conclusion
                                const bar = conclusionBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Recommendation</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                disabled={((display_board_status?? 0 - 0) != 1)}
                                style={{
                                    width: "90px",
                                }}
                                value={recommendationBar ?? 0}
                                onChange={e => {
                                    setrecommendationBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{recommendationBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea disabled={((display_board_status ??0 - 0) != 1)} className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={recommendationRef}
                        value={recommendation ?? ""}
                        onChange={e => { setRecommendation(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >
                        <button className='btn btn-primary'
                            disabled={((display_board_status  ?? 0 - 0) != 1)}
                            onClick={(e) => {
                                const field = "recommendation"
                                const text = recommendation
                                const bar = recommendationBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >


                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Refrences</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                disabled={((display_board_status  ?? 0 - 0) != 1)}
                                style={{
                                    width: "90px",
                                }}
                                value={refrencesBar ?? 0}
                                onChange={e => {
                                    setrefrencesBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{refrencesBar}%</span>
                            </span>
                        </div>
                    </div>

                    <textarea disabled={((display_board_status  ?? 0 - 0) != 1)} className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={refrencesRef}
                        value={refrences ??""}
                        onChange={e => { setRefrences(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >

                        <button className='btn btn-primary'
                            disabled={((display_board_status  ?? 0 - 0) != 1)}
                            onClick={(e) => {
                                const field = "refrences"
                                const text = refrences
                                const bar = refrencesBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}

                <div className={styles.section} >
                    <div className={styles.title} >
                        < h4 className={styles.titleH1} >Acknowledgement</ h4>
                        <div className=' d-flex align-items-center flex-wrap justify-content-between '
                            style={{
                                color: "white",
                                background: "black",
                                padding: '0 19px',
                                borderRadius: "41px",
                            }}
                        >
                            <input type="range" min="0" max="100"
                                style={{
                                    width: "90px",
                                }}
                                disabled={((display_board_status  ?? 0 - 0) != 1)}
                                value={acknowledgementBar ??0}
                                onChange={e => {
                                    setacknowledgementBar(e.target.value)
                                }}
                            />

                            <span className=' d-flex align-items-center flex-wrap justify-content-between '  >
                                <span
                                    style={{
                                        width: "115px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >Completion Ratio</span>

                                <span
                                    style={{
                                        width: "40px",
                                        display: "flex",
                                        justifyContent: "end",
                                    }}
                                >{acknowledgementBar}%</span>
                            </span>
                        </div>
                    </div>
                    <textarea disabled={((display_board_status  ?? 0 - 0) != 1)} className={styles.my_textarea} name="" id="" cols="30" rows="10"
                        // ref={acknowledgementRef}
                        value={acknowledgement??""}
                        onChange={e => { setAcknowledgement(e?.target?.value) }}
                    />
                    <div className=' d-flex align-items-center flex-wrap justify-content-end ' >
                        <button className='btn btn-primary'
                            disabled={((display_board_status  ?? 0 - 0) != 1)}
                            onClick={(e) => {
                                const field = "acknowledgement"
                                const text = acknowledgement
                                const bar = acknowledgementBar
                                if (text) {
                                    handleSend(field, text, bar)
                                }
                            }}
                        >Save</button>
                    </div>
                </div>
                {/* ======================================================================================== */}


            </div >
        )
    }
}

export default DisplayBoard